<template>
    <div style="height:100%;height: 100%;" v-if="content">
        <!-- 标题-->
        <div class="title">{{content.title}}</div>

        <div style="width: 100%;height: 30px;display: flex;margin-top: 30px;"  v-if="typeof content.user!='undefined'">
            <div style="width: 98%;display: flex;overflow: hidden">
                <div @click="circle(content.user.uuid)" claas="hand op sc" style="width: 30px;height: 30px;cursor: pointer">
                    <img :src="content.user.headIco" style="border-radius: 50%;width: 30px;height: 30px">
                </div>
                <div @click="circle(content.user.uuid)" class="head_list hand op sc">{{content.user.nickName}}</div>
                <div style="padding: 2px 20px">|</div>
                <div v-if="$route.params.type < 3" class="head_list">发布于：<span>{{content.createTime | parseTime('{y}-{m}-{d}')}}</span></div>
                <div v-if="$route.params.type == 3" class="head_list">发布于：<span>{{content.time}}</span></div>
                <div style="padding: 2px 20px">|</div>
                <div class="head_list" v-if="$route.params.type == 2">推荐分区：<span style="color: #031F88;font-weight: 400;">{{content.typeNamelist[content.typeNamelist.length - 1]}}</span></div>
                <div v-if="$route.params.type == 2" style="padding: 2px 20px">|</div>
                <div class="head_list" style="display: flex; white-space: nowrap;" v-if="$route.params.type == 1">
                    文章话题：
                    <div style="color: #031F88; font-weight: 400; flex-grow: 1;max-width: 300px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                        #{{content.topicName}}#
                    </div>
                </div>
                <div style="padding: 2px 20px" v-if="$route.params.type == 1">|</div>
                <div class="head_list" v-if="$route.params.type != 3">阅读量：{{content.clickCount}}次</div>
                <div style="padding: 2px 20px" v-if="$route.params.type != 3">|</div>
                <!--   知识仓库     -->
                <div v-if="$route.params.type == 2">
                    <div v-if="content.paymentType == 0 || typeof content.paymentType == 'undefined'"  style="cursor: pointer" @click="vxShare(2)">
                        <div style="float: left;color: #999999;font-size: 16px;margin-top: 3px">分享</div>
                        <div style="float: left;margin: 5px"><svg t="1697778596538" class="icon" viewBox="0 0 1229 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4035" width="20" height="20"><path d="M707.1914515 511.91973863c-15.27555161 0-30.77635287 15.43995796-30.77635287 30.77246925 0 15.54869918 15.50080126 30.77246925 30.77635287 30.77246926 23.37677211 0 38.54746611-15.22377008 38.54746612-30.77246926 0-15.33251129-15.17069401-30.77246925-38.54746612-30.77246925z" fill="#01B702" p-id="4036"></path><path d="M607.09775233 365.49969289c23.27191451 0 38.54746611-15.44384158 38.54746612-38.49439005 0-23.16446783-15.27555161-38.44131397-38.54746612-38.44131399-23.05572661 0-46.1645293 15.22377008-46.1645293 38.44131399 0 23.05054846 23.16058421 38.49439005 46.1645293 38.49439005z" fill="#01B702" p-id="4037"></path><path d="M1053.69403796-109.37837037h-869.9297185c-102.52872565 0-186.41351111 83.88478546-186.41351113 186.41351112v869.9297185c0 102.52872565 83.88478546 186.41351111 186.41351113 186.41351112h869.9297185c102.52484204 0 186.41351111-83.88478546 186.41351112-186.41351112v-869.9297185c0-102.52872565-83.88866907-186.41351111-186.41351112-186.41351112zM491.66506919 681.44858706c-38.44131397 0-69.32511351-7.83195653-107.81820901-15.38947097l-107.65250814 53.93823162 30.77635288-92.59573349c-77.09881584-53.934348-123.20509093-123.36561367-123.20509094-207.91320272 0-146.53137603 138.64116528-261.84755074 307.90204431-261.84755073 151.42214163 0 284.03075856 92.16076863 310.67494524 216.23061111-9.894156-1.08482307-19.73653049-1.84730611-29.74072223-1.84730611-146.19997424 0-261.68573345 109.17747422-261.73880953 243.6890624 0 22.45247179 3.53020587 43.98582139 9.51226722 64.59487068-9.46048569 0.70552336-19.03359621 1.13919369-28.7076807 1.13919368zM945.76838226 789.3755373l23.16058421 76.98619102-84.43496422-46.32246299c-30.77635287 7.71803717-61.71322848 15.3868819-92.38084013 15.3868819-146.47053275 0-261.84755074-99.98884157-261.84755074-223.41012037 0-123.03939003 115.32523646-223.41012037 261.84755074-223.41012037 138.37190131 0 261.57958131 100.31377067 261.57958131 223.41012037 0 69.43385474-46.10627508 130.92442263-107.92565571 177.35951044z" fill="#01B702" p-id="4038"></path><path d="M876.55718812 511.91973863c-15.22765369 0-30.61065197 15.43995796-30.61065196 30.77246925 0 15.54869918 15.43607435 30.77246925 30.61065196 30.77246926 23.16058421 0 38.54746611-15.22377008 38.54746611-30.77246926 0-15.33251129-15.3868819-30.77246925-38.54746611-30.77246925z" fill="#01B702" p-id="4039"></path><path d="M391.6244461 288.56398885c-23.11139177 0-46.38330627 15.27555161-46.38330627 38.44131399 0 23.05184301 23.27191451 38.49439005 46.38330627 38.49439005 23.10362453 0 38.44131397-15.44384158 38.44131397-38.49439005-0.00129454-23.21883843-15.33768944-38.44131397-38.44131397-38.44131399z" fill="#01B702" p-id="4040"></path></svg></div>
                    </div>
                </div>
                <!--   朋友圈  -->
                <div v-if="$route.params.type == 1">
                    <div v-if="$route.params.type == 1 && content.paymentType == 0 || typeof content.paymentType == 'undefined'"  style="cursor: pointer" @click="vxShare(1)">
                        <div style="float: left;color: #999999;font-size: 16px;margin-top: 3px">分享</div>
                        <div style="float: left;margin: 5px"><svg t="1697778596538" class="icon" viewBox="0 0 1229 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4035" width="20" height="20"><path d="M707.1914515 511.91973863c-15.27555161 0-30.77635287 15.43995796-30.77635287 30.77246925 0 15.54869918 15.50080126 30.77246925 30.77635287 30.77246926 23.37677211 0 38.54746611-15.22377008 38.54746612-30.77246926 0-15.33251129-15.17069401-30.77246925-38.54746612-30.77246925z" fill="#01B702" p-id="4036"></path><path d="M607.09775233 365.49969289c23.27191451 0 38.54746611-15.44384158 38.54746612-38.49439005 0-23.16446783-15.27555161-38.44131397-38.54746612-38.44131399-23.05572661 0-46.1645293 15.22377008-46.1645293 38.44131399 0 23.05054846 23.16058421 38.49439005 46.1645293 38.49439005z" fill="#01B702" p-id="4037"></path><path d="M1053.69403796-109.37837037h-869.9297185c-102.52872565 0-186.41351111 83.88478546-186.41351113 186.41351112v869.9297185c0 102.52872565 83.88478546 186.41351111 186.41351113 186.41351112h869.9297185c102.52484204 0 186.41351111-83.88478546 186.41351112-186.41351112v-869.9297185c0-102.52872565-83.88866907-186.41351111-186.41351112-186.41351112zM491.66506919 681.44858706c-38.44131397 0-69.32511351-7.83195653-107.81820901-15.38947097l-107.65250814 53.93823162 30.77635288-92.59573349c-77.09881584-53.934348-123.20509093-123.36561367-123.20509094-207.91320272 0-146.53137603 138.64116528-261.84755074 307.90204431-261.84755073 151.42214163 0 284.03075856 92.16076863 310.67494524 216.23061111-9.894156-1.08482307-19.73653049-1.84730611-29.74072223-1.84730611-146.19997424 0-261.68573345 109.17747422-261.73880953 243.6890624 0 22.45247179 3.53020587 43.98582139 9.51226722 64.59487068-9.46048569 0.70552336-19.03359621 1.13919369-28.7076807 1.13919368zM945.76838226 789.3755373l23.16058421 76.98619102-84.43496422-46.32246299c-30.77635287 7.71803717-61.71322848 15.3868819-92.38084013 15.3868819-146.47053275 0-261.84755074-99.98884157-261.84755074-223.41012037 0-123.03939003 115.32523646-223.41012037 261.84755074-223.41012037 138.37190131 0 261.57958131 100.31377067 261.57958131 223.41012037 0 69.43385474-46.10627508 130.92442263-107.92565571 177.35951044z" fill="#01B702" p-id="4038"></path><path d="M876.55718812 511.91973863c-15.22765369 0-30.61065197 15.43995796-30.61065196 30.77246925 0 15.54869918 15.43607435 30.77246925 30.61065196 30.77246926 23.16058421 0 38.54746611-15.22377008 38.54746611-30.77246926 0-15.33251129-15.3868819-30.77246925-38.54746611-30.77246925z" fill="#01B702" p-id="4039"></path><path d="M391.6244461 288.56398885c-23.11139177 0-46.38330627 15.27555161-46.38330627 38.44131399 0 23.05184301 23.27191451 38.49439005 46.38330627 38.49439005 23.10362453 0 38.44131397-15.44384158 38.44131397-38.49439005-0.00129454-23.21883843-15.33768944-38.44131397-38.44131397-38.44131399z" fill="#01B702" p-id="4040"></path></svg></div>
                    </div>
                </div>
                <!--  今日头条 -->
                <div v-if="$route.params.type == 3">
                    <div v-if="content.paymentType == 0 || typeof content.paymentType == 'undefined'"  style="cursor: pointer" @click="vxShare(3)">
                        <div style="float: left;color: #999999;font-size: 16px;margin-top: 3px">分享</div>
                        <div style="float: left;margin: 5px"><svg t="1697778596538" class="icon" viewBox="0 0 1229 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4035" width="20" height="20"><path d="M707.1914515 511.91973863c-15.27555161 0-30.77635287 15.43995796-30.77635287 30.77246925 0 15.54869918 15.50080126 30.77246925 30.77635287 30.77246926 23.37677211 0 38.54746611-15.22377008 38.54746612-30.77246926 0-15.33251129-15.17069401-30.77246925-38.54746612-30.77246925z" fill="#01B702" p-id="4036"></path><path d="M607.09775233 365.49969289c23.27191451 0 38.54746611-15.44384158 38.54746612-38.49439005 0-23.16446783-15.27555161-38.44131397-38.54746612-38.44131399-23.05572661 0-46.1645293 15.22377008-46.1645293 38.44131399 0 23.05054846 23.16058421 38.49439005 46.1645293 38.49439005z" fill="#01B702" p-id="4037"></path><path d="M1053.69403796-109.37837037h-869.9297185c-102.52872565 0-186.41351111 83.88478546-186.41351113 186.41351112v869.9297185c0 102.52872565 83.88478546 186.41351111 186.41351113 186.41351112h869.9297185c102.52484204 0 186.41351111-83.88478546 186.41351112-186.41351112v-869.9297185c0-102.52872565-83.88866907-186.41351111-186.41351112-186.41351112zM491.66506919 681.44858706c-38.44131397 0-69.32511351-7.83195653-107.81820901-15.38947097l-107.65250814 53.93823162 30.77635288-92.59573349c-77.09881584-53.934348-123.20509093-123.36561367-123.20509094-207.91320272 0-146.53137603 138.64116528-261.84755074 307.90204431-261.84755073 151.42214163 0 284.03075856 92.16076863 310.67494524 216.23061111-9.894156-1.08482307-19.73653049-1.84730611-29.74072223-1.84730611-146.19997424 0-261.68573345 109.17747422-261.73880953 243.6890624 0 22.45247179 3.53020587 43.98582139 9.51226722 64.59487068-9.46048569 0.70552336-19.03359621 1.13919369-28.7076807 1.13919368zM945.76838226 789.3755373l23.16058421 76.98619102-84.43496422-46.32246299c-30.77635287 7.71803717-61.71322848 15.3868819-92.38084013 15.3868819-146.47053275 0-261.84755074-99.98884157-261.84755074-223.41012037 0-123.03939003 115.32523646-223.41012037 261.84755074-223.41012037 138.37190131 0 261.57958131 100.31377067 261.57958131 223.41012037 0 69.43385474-46.10627508 130.92442263-107.92565571 177.35951044z" fill="#01B702" p-id="4038"></path><path d="M876.55718812 511.91973863c-15.22765369 0-30.61065197 15.43995796-30.61065196 30.77246925 0 15.54869918 15.43607435 30.77246925 30.61065196 30.77246926 23.16058421 0 38.54746611-15.22377008 38.54746611-30.77246926 0-15.33251129-15.3868819-30.77246925-38.54746611-30.77246925z" fill="#01B702" p-id="4039"></path><path d="M391.6244461 288.56398885c-23.11139177 0-46.38330627 15.27555161-46.38330627 38.44131399 0 23.05184301 23.27191451 38.49439005 46.38330627 38.49439005 23.10362453 0 38.44131397-15.44384158 38.44131397-38.49439005-0.00129454-23.21883843-15.33768944-38.44131397-38.44131397-38.44131399z" fill="#01B702" p-id="4040"></path></svg></div>
                    </div>
                </div>
            </div>
            <div class="right op sc hand" style="margin-top: 2px; position: relative;">
                <el-dropdown @command="more_action" v-if="content.uuid === user.uuid">
                    <span class="el-dropdown-link">
                      <i class="el-icon-caret-bottom" style="font-size: 24px"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" >
                        <label v-if="typeof content.paymentType == 'undefined'">
                            <el-dropdown-item  command="edit">编辑内容</el-dropdown-item>
                        </label>
                        <label v-else-if="content.paymentType == 0">
                            <el-dropdown-item  command="edit">编辑内容</el-dropdown-item>
                        </label>
                        <el-dropdown-item  command="delete" >删除内容</el-dropdown-item>
                        <!--     <el-dropdown-item command="share_wechat">微信分享</el-dropdown-item>-->
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="300px">
                <div>
                    <vue-qr
                            :text="qr_imgUrl"
                            :size="250"
                            :logoSrc="qr_logo"
                            :logoScale="0.2">
                    </vue-qr>
                </div>
            </el-dialog>
        </div>
        <div class="link" >
            <div v-if="content.form == 1" style="padding: 12px  20px;">
                <div  class="comment">版权声明：本文为博主原创文章，遵循百工宝版权协议，转载请附上原文出处链接和本声明。 </div>
                <div class="comment" style="cursor: pointer">本文链接：<span style="color:#2970FF ">{{address}}</span></div>
            </div>
            <div v-if="content.form == 2" style="padding: 12px  20px;">
                <div class="comment" style="cursor: pointer">来自于：<span style="color:#2970FF ">{{content.reprintedAddress}}</span></div>
            </div>
        </div>
        <!-- 内容  由于我写在这里有点懵 先用v-if 和else 判断一下 -->
        <!-- 判断类型 不等于1是没有支付或者已支付  -->

        <div class="follow" style="width: 100%;margin-top: 5px" v-html="content.content"></div>
        <div v-if="is_login === 0 && $route.params.type== 2 &&  content.paymentType == 3 && content.PayStatus == 0 && content.payAmt > 0">
            <div style="width: 100%;display: flex;justify-content: center">
                <div style="width: 16px;height: 18px;margin: 5px 5px 3px 0">
                    <img src="https://baigongbao.oss-cn-beijing.aliyuncs.com/assets/index/menu/hongbao/icon6.png" style="width: 16px;height: 18px">
                </div>
                <div style="height: 21px;font-size: 17px;margin-top: 2px">资料有偿</div>
            </div>
            <div v-if="typeof content=='object'" style="margin-top: 10px;overflow: hidden;display: flex;justify-content: center;width: 100%;">
                <el-button style="overflow: hidden;" @click="showFullContent" type="info" plain>购买资料：￥{{content.payAmt}}</el-button>
            </div>
        </div>

        <div v-if="is_login === 1">
            <div v-if="$route.params.type== 2 &&  content.paymentType == 3 && content.PayStatus == 0 && content.payAmt > 0 && content.user.uuid !== user.uuid">
                <div style="width: 100%;display: flex;justify-content: center">
                    <div style="width: 16px;height: 18px;margin: 5px 5px 3px 0">
                        <img src="https://baigongbao.oss-cn-beijing.aliyuncs.com/assets/index/menu/hongbao/icon6.png" style="width: 16px;height: 18px">
                    </div>
                    <div style="height: 21px;font-size: 17px;margin-top: 2px">资料有偿</div>
                </div>
                <div v-if="typeof content=='object'" style="margin-top: 10px;overflow: hidden;display: flex;justify-content: center;width: 100%;">
                    <el-button style="overflow: hidden;" @click="showFullContent" type="info" plain>购买资料：￥{{content.payAmt}}</el-button>
                </div>
            </div>
        </div>
        <!--   附件   -->
        <!--  content.enclosure.length > 0 && ( [0,1].indexOf(content.paymentType)  >= -1  ||  ( content.paymentType == 2 && content.PayStatus == 1)  )-->
        <!--                首先得有附件                && (               附件免费                     ||   (       附件收费          &&          支付了       )  )              -->
        <!--    <div v-if="type != 2 && typeof content.enclosure !='undefined' && ( [0,1].indexOf(content.paymentType)  >= -1  ||  ( content.paymentType == 3 && content.PayStatus == 1)  )">-->
        <div v-if="$route.params.type != 3">
            <div v-if="(content.enclosure && content.enclosure.length > 0) && typeof content.enclosure!='undefined'" style="color: #999999;font-size: 16px;padding-top: 5px;clear: both">附件：</div>
            <label>
                <div v-for="(name,size) in content.enclosure" :key="size" style="width: 100%;height: 48px;background: #F1F1F1;margin-top: 5px;">
                    <div style="width: 22px;height: 28px;padding: 10px 22px;float: left">
                        <img src="https://baigongbao.oss-cn-beijing.aliyuncs.com/assets/index/menu/hongbao/icon10.png" style="width: 22px;height: 28px;">
                    </div>
                    <div style="height: 19px;font-size: 16px;float: left;padding: 13px 0;width: 1020px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">{{name.name}}</div>
                        <div v-if="content.paymentType == 3 && content.PayStatus == 1"  style="float: right;margin: 15px 20px;cursor: pointer" @click="download(name['url'],name['name'],name['hash'])">
                            <div style="float: left;margin-top: 3px"><svg t="1694497757251" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4270" width="20" height="18"><path d="M828.975746 894.125047 190.189132 894.125047c-70.550823 0-127.753639-57.18542-127.753639-127.752616L62.435493 606.674243c0-17.634636 14.308891-31.933293 31.93227-31.933293l63.889099 0c17.634636 0 31.93227 14.298658 31.93227 31.933293l0 95.821369c0 35.282574 28.596292 63.877843 63.87682 63.877843L765.098927 766.373455c35.281551 0 63.87682-28.595268 63.87682-63.877843l0-95.821369c0-17.634636 14.298658-31.933293 31.943526-31.933293l63.877843 0c17.634636 0 31.933293 14.298658 31.933293 31.933293l0 159.699212C956.729385 836.939627 899.538849 894.125047 828.975746 894.125047L828.975746 894.125047zM249.938957 267.509636c12.921287-12.919241 33.884738-12.919241 46.807049 0l148.97087 148.971893L445.716876 94.89323c0-17.634636 14.300704-31.94762 31.933293-31.94762l63.875796 0c17.637706 0 31.945573 14.312984 31.945573 31.94762l0 321.588299 148.97087-148.971893c12.921287-12.919241 33.875528-12.919241 46.796816 0l46.814212 46.818305c12.921287 12.922311 12.921287 33.874505 0 46.807049L552.261471 624.930025c-1.140986 1.137916-21.664416 13.68365-42.315758 13.69286-20.87647 0.010233-41.878806-12.541641-43.020816-13.69286L203.121676 361.13499c-12.922311-12.933567-12.922311-33.884738 0-46.807049L249.938957 267.509636 249.938957 267.509636z" fill="#FF9800" p-id="4271"></path></svg></div>
                            <div style="float: left;width: 32px;height: 18px;color: #FF9800;font-size: 16px;" >下载</div>
                        </div>
                        <div v-if="content.paymentType == 0 || typeof content.paymentType == 'undefined'"  style="float: right;margin: 15px 20px;cursor: pointer" @click="download(name['url'],name['name'],name['hash'])">
                            <div style="float: left;margin-top: 3px"><svg t="1694497757251" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4270" width="20" height="18"><path d="M828.975746 894.125047 190.189132 894.125047c-70.550823 0-127.753639-57.18542-127.753639-127.752616L62.435493 606.674243c0-17.634636 14.308891-31.933293 31.93227-31.933293l63.889099 0c17.634636 0 31.93227 14.298658 31.93227 31.933293l0 95.821369c0 35.282574 28.596292 63.877843 63.87682 63.877843L765.098927 766.373455c35.281551 0 63.87682-28.595268 63.87682-63.877843l0-95.821369c0-17.634636 14.298658-31.933293 31.943526-31.933293l63.877843 0c17.634636 0 31.933293 14.298658 31.933293 31.933293l0 159.699212C956.729385 836.939627 899.538849 894.125047 828.975746 894.125047L828.975746 894.125047zM249.938957 267.509636c12.921287-12.919241 33.884738-12.919241 46.807049 0l148.97087 148.971893L445.716876 94.89323c0-17.634636 14.300704-31.94762 31.933293-31.94762l63.875796 0c17.637706 0 31.945573 14.312984 31.945573 31.94762l0 321.588299 148.97087-148.971893c12.921287-12.919241 33.875528-12.919241 46.796816 0l46.814212 46.818305c12.921287 12.922311 12.921287 33.874505 0 46.807049L552.261471 624.930025c-1.140986 1.137916-21.664416 13.68365-42.315758 13.69286-20.87647 0.010233-41.878806-12.541641-43.020816-13.69286L203.121676 361.13499c-12.922311-12.933567-12.922311-33.884738 0-46.807049L249.938957 267.509636 249.938957 267.509636z" fill="#FF9800" p-id="4271"></path></svg></div>
                            <div style="float: left;width: 32px;height: 18px;color: #FF9800;font-size: 16px;" >下载</div>
                        </div>
                    </div>
                </label>
            </div>
        <!--  </div>-->


        <!--    首先得有附件 &&   附件收费    &&   没支付  &&  不是自己得-->
        <!--            <div v-if=" typeof content.enclosure !='undefined' && content.paymentType == 2 && content.PayStatus == 0 &&  content.user.uuid !== user.uuid">-->
        <!--                 <div   style="width: 100%">-->
        <!--                     <div style="width: 100%;display: flex;justify-content: center">-->
        <!--                         <div style="width: 16px;height: 18px;margin: 5px 5px 3px 0">-->
        <!--                             <img src="../../../assets/imgs/index/release.png" style="width: 16px;height: 18px">-->
        <!--                         </div>-->
        <!--                         <div style="height: 21px;font-size: 17px;margin-top: 2px">附件有偿</div>-->
        <!--                     </div>-->
        <!--                     <div style="text-align: center;margin-top: 10px;overflow: hidden"><el-button @click="showFullContent" type="info" plain>付费下载：￥{{content.payAmt}}</el-button></div>-->
        <!--                 </div>-->
        <!--            </div>-->
        <label v-if="is_login == 1 && $route.params.type != 3">
            <div style="width: 100%;border-top: 1px solid #BDBFC1;margin-top: 40px;"></div>
            <div style="width: 100%;height: 100%;margin-bottom: 20px;">
                <reply :content="content" :intermediateValue.sync="intermediateValue"></reply>
            </div>
        </label>
        <label v-if="is_login == 0 && $route.params.type != 3">
            <div style="width: 100%;border-top: 1px solid #BDBFC1;margin-top: 40px;"></div>
            <span style="font-size: 14px;">评论区</span>
            <div style="overflow: hidden;background: #FFFFFF;white-space: pre-wrap;width: calc(100% - 30px;);border-radius: 5px;padding: 50px 0px 50px 0px;">
                <div style="display: flex;justify-content: center">
                    <div class="op sc hand"><el-button type="primary"  style="font-size: 15px;" @click="logintoview">登录查看评论</el-button></div>
                </div>
            </div>
        </label>

        <!--   支付   -->
        <el-dialog  width="400px" :visible.sync="compensation"  v-if="typeof content.user!='undefined' && $route.params.type != 3" :close-on-click-modal="false">
            <AaDaPayCode ref="child" type="2" payType="14" :accountType="content.user.userType" :memberId="content.individMemberId"  :payAmt="content.payAmt" :collectionUuid="content.user.uuid" :orderNo="orderNo" @change="changeOrder($event)"></AaDaPayCode>
        </el-dialog>
    </div>
</template>

<script>
    import AaDaPayCode  from "../../../components/common/Pay/AaDaPayCode";
    import reply from "./reply";
    import {formatTime, parseTime} from '@/utils/utils';
    export default {
        components: {
            reply,
            AaDaPayCode
        },

        computed: {
            user() {
                return this.$store.state.user
            },
            is_login(){
                return this.$store.state.is_login
            },
	        intermediateValue: {
		        get() {
			        return this.parentValue;
		        },
		        set(value) {
			        // 发送值到父组件
			        this.$emit('update:parentValue', value);
		        },
	        },
        },
        filters: {
            parseTime, formatTime
        },
        props:{
            content:{
                type:Object,
                default(){
                    return false
                }
            },
	        parentValue: String,

        },
        data () {
            return {
                isPaid: false, // 标记是否已付费
                compensation:false, // 有偿弹窗
                address:window.location.origin+window.location.pathname,
                dialogVisible:false,
                qr_imgUrl: this.$store.state.mobileUrl,
                qr_logo: require('@/assets/imgs/other/bgb.png'),
                orderNo:'',
            }
        },
        created() {
            var that = this;
            //预支付订单监听
            this.$EventBus.$EventBus.$off("prePayOrder");
            this.$EventBus.$on("prePayOrder", (data) => {
                this.$nextTick(() => {
                    if (data.code == 100) {
                        that.bankPay(data.toPay);
                    }
                });
            });
        },
        mounted:function(){
            //监听支付成功
            this.$EventBus.$EventBus.$off("payMsg");
            this.$EventBus.$on("payMsg", (data) => {
                this.$nextTick(() => {
                    if (data.code == 100) {
                        location.reload();
                    }
                });
            });

            // 在页面初始化请求判断 订单有没有支付过
            // this.payKnowledgeList()
        },
        methods:{
            //下拉菜单触发的方法
            more_action:function(e){
                if (this.is_login == 0) {
                    this.err("请先登录");
                    return;
                }
                var that = this;
                if (e == "collection_user") {
                    this.collection_user();
                }
                if (e == "edit") {
                    // type = 1 笔记 type = 2 是知识仓库 3头条
                    if(this.$route.params.type == 1){
                        this.utils.a('/content/add/' + this.content.id);
                    }else if(this.$route.params.type == 2){
                        this.utils.a('/filebase/upload/' + this.content.id);
                    }else if(this.$route.params.type == 3){
                        this.utils.a('/content/headlines/' + this.content.id);
                    }
                }

                if (e == "delete") {
                    if(this.$route.params.type == 1){
                        that.$confirm('删除朋友圈文章后无法恢复，确认删除吗？').then(_ => {
                            that.newApi.InspirationDelete({
                                id:this.content.id,
                            }).then((res) => {
                                if(res.isSuccess == 1){
                                    that.utils.sus(res.data);
                                    that.utils.a('/circle/index/');
                                }
                            })

                        })
                    }else if (this.$route.params.type == 2) {
                        that.$confirm('删除知识仓库文章后无法恢复，确认删除吗？').then(_ => {
                            that.newApi.delKnowledge({
                                id:this.content.id,
                                type:5,
                            }).then((res) => {
                                if(res.isSuccess == 1){
                                    that.utils.sus(res.data);
                                    that.utils.a('/filebase/index/');
                                }
                            })

                        })
                    }else if (this.$route.params.type == 3) {
                        that.$confirm('删除头条文章后无法恢复，确认删除吗？').then(_ => {
                            that.newApi.delHeadLine({
                                id:this.content.id,
                                type:5,
                            }).then((res) => {
                                if(res.isSuccess == 1){
                                    that.utils.sus(res.data);
                                    that.utils.a('/');
                                }
                            })

                        })
                    }
                }
            },

            // 支付按钮
            showFullContent(){
                var that = this;
                if (that.is_login == 0){
                    this.$store.commit('setShowLoginPopup', true);
                    return
                }
                that.newApi.payKnowledge({ knowledgeId:that.content.id,paidUuid:that.user.uuid}).then((res)=>{
                    if (res.isSuccess == 1) {
                        that.orderNo = res.data.orderNo;
                        // <AaDaPayCode ref="child" type="2" payType="14" :accountType="content.user.userType" :memberId="content.individMemberId"  :payAmt="content.payAmt" :collectionUuid="content.user.uuid" :orderNo="orderNo" @change="changeOrder($event)"></AaDaPayCode>
                        let payParams = that.$store.state.payParams;
                        payParams.type = 2;
                        payParams.payType = 14;
                        payParams.memberId = that.content.individMemberId;
                        payParams.payAmt = that.content.payAmt;
                        payParams.collectionUuid = that.content.user.uuid;
                        payParams.orderNo = that.orderNo;
                        that.sign = that.utils.random_string(6);
                        that.newApi.addAndSavePrePayOrder({type: 1,payParams: JSON.stringify(payParams),sign: that.sign}).then(() => {
                            that.b('/newAdaPay/?sign=' + that.sign);
                        })
                    }
                })
            },

            //子组件传过来的订单号 此方法在父页面必写
            changeOrder(order){
                this.orderNo = order;
            },

            //  立即支付
            bankPay(data){
                var that = this;
                var payParams = {};
                payParams.orderNo = data.orderNo;
                payParams.code = data.code;
                payParams.payPwd = data.payPwd;
                //请求汇付接口
                that.newApi.settleAccountPennyDetermine(payParams).then(() => { })
            },

            // 下载附件
            download(url,name){
                this.utils.download(url,name)
            },

            // 微信分享
            vxShare(type){
                this.dialogVisible = true;
                // type 1朋友圈  type 2知识仓库  type 3今日头条
                this.qr_imgUrl = this.qr_imgUrl + "articleInfo/?type="+type+"&id=" + this.content.id;
                console.log(this.qr_imgUrl)
            },

            // 跳转到个人空间
            circle(uuid){
                window.open('/circle/mySpace/'+uuid)
            },
            // 登陆查看事件
            logintoview(){
                this.$store.commit('setShowLoginPopup', true);
            }
        }
    }
</script>

<style scoped>
    .title {
        width: 100%;
        height: 35px;
        font-size: 25px;
        padding-top: 40px;

    }
    .head_list {
        font-size: 16px;
        height: 25px;
        margin: 3px 5px;
        color: #444444;
        white-space: nowrap;
        cursor: pointer
    }
    .link {
        width: 100%;
        height: auto;
        background:#F7F7F7;
        margin-top: 10px;
    }
    .comment {
        width: 100%;
        overflow: hidden;
        min-height: 21px;
        font-size: 14px;
        color: #666666;
        word-wrap: break-word;
    }
    .follow>>>img {
        max-width: 100%;
    }
    .follow>>>p{
        white-space: pre-line;
    }
    /deep/ .el-button--info {
        background: #f4f4f5;
        border-color: #d3d4d6;
    }
    /deep/ .el-dialog {
        height: 400px;
    }
</style>
